import axios from 'axios'

const baseHost = (window.env && window.env.baseHost) || ''
const endpoint = '/user-resources?suggestions=true'

export const get = () => axios.get(endpoint, { baseURL: baseHost, withCredentials: true, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
